<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content">
        <!-- 复选框组 on-change 类似于watch-->
        <CheckboxGroup v-model="dataList" @on-change="areaChange">
          <drop
            class="sort-item"
            v-for="(item,index) in initdata.dataList"
            :data-index="index"
            :key="item.label"
            @eldrop="eldrop"
            :el-index="index"
          >
            <!-- 复选框 -->
            <Checkbox :label="index" class="sort-checkbox">
              <span class="sort-label">{{item.label}}</span>
            </Checkbox>
            <!-- 复选框人数 -->
            <span class="sort-number">{{item.number}}</span>
          </drop>
        </CheckboxGroup>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
  import drop from "../dragger/drop";
  export default {
    created() {
      this.areaChange = this._.debounce(this._areaChange, this.debounceTime, false);
    },
    mounted() {},
    props: ["initdata", "filterListIndex",'debounceTime'],
    data() {
      return {
        dataList: []
      };
    },
    methods: {
      /* 复选组勾选装填改变 */
      _areaChange() {
        this.$emit("event", {
          fn: "areaChange",
          params: {
            selectedIndex: this.dataList,
            filterListIndex: this.filterListIndex
          }
        });
      },
      areaChange() {}, // 只是个空壳
      eldrop(e) {
        this.$emit("event", {
          fn: "orgDrop",
          params: {
            filterListIndex: this.filterListIndex,
            ...e
          }
        });
      },
      reset(){
        this.dataList = []
        this.$emit("event", {
          fn: "reset",
        })
      }
    },
    components: {
      drop
    }
  };
</script>
<style scoped lang="less">
@import "./collapse.less";
</style>
